<template>
    <input type="text" class="form-control inputElement datepicker" :id="'value-'+id" :value="value" autocomplete="off">
</template>

<script>
import "bootstrap-datepicker"
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min.js"
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.css"
export default {
  name: "DateInput",
  data() {
    return {
      output: {}
    };
  },
  mounted() {
       $('#value-'+this.id).datepicker({
        format: 'dd.mm.yyyy',
        todayHighlight: true,
        //format: 'yyyy.mm.dd',
        language: 'de'
    });
  },
  props: ["value", "id"]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/DateInput.vue